<template>
  <div class="nav_box">
    <div
      class="painting_box"
      v-if="$padFalg == 'other' && $store.state.gameType == 2"
      @click="$router.push({ path: './painting' })"
    ></div>
    <div class="nav_list">
      <div
        :class="`nav_${item.icon}`"
        v-for="(item, index) in navList"
        @click="goDetail(item.name)"
        :key="index"
      >
        <img
          v-if="$store.state.gameType == 2"
          :src="
            require(`../../../../../assets/img/gl/gameIntro/nav-${item.icon}.png`)
          "
          alt=""
        />
        <img
          v-if="$store.state.gameType == 4"
          :src="
            require(`../../../../../assets/img/lhlr/gameIntro/nav-${item.icon}.png`)
          "
          alt=""
        />
        <img
          v-if="$store.state.gameType == 5"
          :src="
            require(`../../../../../assets/img/rox/gameIntro/nav-${item.icon}.png`)
          "
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import get from '@/api/get';
export default {
  components: {},
  data() {
    return {
      navList: []
    };
  },
  computed: {},
  watch: {
    '$store.state.token'(token) {
      if (token != '') {
        this.resolveHander && this.resolveHander();
      }
    }
  },
  methods: {
    goDetail(val) {
      if (val == '全部攻略') {
        this.$router.push({ name: 'detailPage' });
      } else {
        this.$router.push({ name: 'detailPage', params: { title: val } });
      }
    },
    getNavList() {
      get.getGlGameintroNavIcon({ locate: 'f_gl_jg' }).then((res) => {
        this.navList = res.data.data.map((item) => {
          return {
            icon: item.ftrKey,
            name: item.ftrName
          };
        });
      });
    }
  },
  async created() {
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    this.getNavList();
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
.gl .gameIntro_content .nav_box {
  width: 100%;
  background: #ffffff;
  box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
  border-radius: 0.2rem;
  margin-top: 0.21rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.3rem 0.2rem;
  box-sizing: border-box;
  .painting_box {
    width: 6.4rem;
    height: 1.3rem;
    background: url('~@/assets/img/gl/gameIntro/painting-icon.jpg');
    background-size: 100% 100%;
    margin-bottom: 0.28rem;
  }
  .nav_list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // margin-top: 0.3rem;
    div {
      width: 0.95rem;
      height: 0.94rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nav_gkgl {
      width: 0.94rem;
      height: 0.95rem;
    }
    .nav_jbsc {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_jspy {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_wfgl {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_qbgl {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_zxgl {
      width: 0.94rem;
      height: 0.94rem;
    }
  }
}
.lhlr .gameIntro_content .nav_box {
  width: 100%;
  background: #ffffff;
  box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
  border-radius: 0.2rem;
  margin-top: 0.21rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.3rem 0.2rem;
  box-sizing: border-box;
  .painting_box {
    width: 6.4rem;
    height: 1.3rem;
    background: url('~@/assets/img/gl/gameIntro/painting-icon.jpg');
    background-size: 100% 100%;
    margin-bottom: 0.28rem;
  }
  .nav_list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // margin-top: 0.3rem;
    div {
      width: 0.95rem;
      height: 0.94rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nav_gkgl {
      width: 0.94rem;
      height: 0.95rem;
    }
    .nav_jbsc {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_jspy {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_wfgl {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_qbgl {
      width: 0.95rem;
      height: 0.94rem;
    }
    .nav_zxgl {
      width: 0.94rem;
      height: 0.94rem;
    }
  }
}
.rox .gameIntro_content .nav_box {
  .nav_list {
    div {
      width: 0.95rem;
      height: 1.04rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>